import dayjs from "dayjs";

export const formatDate = (value, format = "DD-MM-YYYY") => {
  return dayjs(value).format(format);
};
